import { NgModule } from '@angular/core';
import { PrismBackgroundComponent } from './prism-background.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        PrismBackgroundComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        PrismBackgroundComponent
    ]
})
export class NcPrismBackgroundModule { }